module.exports = __webpack_public_path__ + "img/shipment-box.9a34454b.svg";